import { NavigationExtras } from "@angular/router";

export class BreadCumb{
    constructor(title:string,route:any[], extras?:NavigationExtras){
        this.title=title;
        this.route=route;
        this.extras=extras;
    }
    title:string;
    route:any[];
    extras?:NavigationExtras;
}
